import { DateTime } from "luxon";

/**
 * Returns the ordinal suffix for a given day (e.g., 1st, 2nd, 3rd, 4th, etc.)
 */
const getNumberSuffix = (day: number): string => {
  if (day === 11 || day === 12 || day === 13) return "th";

  let lastDigit = day.toString().slice(-1);

  switch (lastDigit) {
    case "1":
      return "st";
    case "2":
      return "nd";
    case "3":
      return "rd";
    default:
      return "th";
  }
};

/**
 * Formats an ISO date string into format like "Tuesday June 23rd, 10:00 BST"
 * This is intentionally different to the existing date formatting used elsewhere
 */
export function formatWebinarDate(iso: string): string | null {
  const dt = DateTime.fromISO(iso).setZone("Europe/London");
  if (!dt.isValid) return null;

  const suffix = getNumberSuffix(dt.day);
  // Derive the UK label directly (BST/GMT). Luxon's zone-name token can fall
  // back to "GMT+1" depending on the runtime's ICU data.
  const tzLabel = dt.isInDST ? "BST" : "GMT";

  return `${dt.toFormat("cccc LLLL")} ${dt.day}${suffix}, ${dt.toFormat("HH:mm")} ${tzLabel}`;
}
